window.addEventListener('load', function () {
    document.querySelectorAll('[data-enc]').forEach(function (link) {
        const value = atob(link.getAttribute('data-enc'));
        const action = link.getAttribute("data-action");
        link.setAttribute("href", action + ":".concat(action === 'tel' ? value.replace(/[^\d\+]/g, '') :  value ));
        link.innerHTML = atob(link.getAttribute('data-enc'));
    });
});
